<template>
  <div>
    <vs-card>
      <div class="card-body">
        <vs-row vs-w="12">
          <div class="m-2" v-for="(item, index) in reports" :key="index">
            <router-link :to="item.url">
              <vs-card actionable class="cardx" fixedHeight>
                <div slot="header">
                  <h5 class="font-bold">{{ item.name }}</h5>
                </div>
              </vs-card>
            </router-link>
          </div>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "reportsTTC",
  data() {
    return {
      reports: [
        { url: '/ttc/reports/touchpoint-overall-participation', name: 'Touchpoint overall participation' },
        { url: '/ttc/reports/touchpoint-overall-result', name: 'Touchpoint overall result' },
        { url: '/ttc/reports/performances-per-region-service', name: 'Performance par région et par service' },
        { url: '/ttc/reports/performances-per-team-service', name: 'Performance par équipe et par service' },
        { url: '/ttc/reports/low-performances', name: 'Low Performance' },
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
// h5 {
//   height: 60px;
// }

.con-vs-card.fixedHeight {
  width: 210px;
}
</style>
